import http from "@/utils/request";

const goodsForRecordApi = {
  list: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.queryGoodsDeclareRecordList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  store: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.createGoodsDeclareRecord",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  importPreview: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.previewDeclareGoodsImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  batchImport: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.importDeclareGoods",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  sendWms: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.goodsSendWms",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  exportDeclareGoods: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.exportDeclareGoods",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default goodsForRecordApi;
